/**
 * @generated SignedSource<<e734d2a036ae8730e2573281e8c12e3a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChatChannelKind = "chat_bot" | "custom" | "default" | "direct_message" | "%future added value";
export type ProductRole = "instructor" | "manager" | "member" | "%future added value";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type StreamChatContext_ChannelsFragment$data = {
  readonly chatChannels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly app: {
          readonly navSectionId: string | null;
        } | null;
        readonly appId: string | null;
        readonly externalChannelId: string;
        readonly id: string;
        readonly kind: ChatChannelKind;
        readonly product: {
          readonly navSectionId: string | null;
          readonly status: ProductStatus;
          readonly viewerMembership: {
            readonly id: string;
            readonly role: ProductRole;
          } | null;
        } | null;
        readonly productId: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "StreamChatContext_ChannelsFragment";
};
export type StreamChatContext_ChannelsFragment$key = {
  readonly " $data"?: StreamChatContext_ChannelsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StreamChatContext_ChannelsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "navSectionId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StreamChatContext_ChannelsFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeProductLevel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "default",
            "custom",
            "direct_message"
          ]
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "last_message_sent_at"
          }
        }
      ],
      "concreteType": "ChatChannelNodeConnection",
      "kind": "LinkedField",
      "name": "chatChannels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatChannelNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ChatChannel",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "productId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "externalChannelId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "appId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Product",
                  "kind": "LinkedField",
                  "name": "product",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductMembership",
                      "kind": "LinkedField",
                      "name": "viewerMembership",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "role",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductApp",
                  "kind": "LinkedField",
                  "name": "app",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "chatChannels(includeProductLevel:true,kinds:[\"default\",\"custom\",\"direct_message\"],orderBy:{\"direction\":\"DESC\",\"field\":\"last_message_sent_at\"})"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "d855d212b230028c43560fdce87fcf61";

export default node;
